import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import MessagingContainer from '../messaging/MessagingContainer';
import { useMessage } from '../messaging/useMessage';
import { devices } from '../styles/viewports.styles';
import { MessagingContentHolder } from './AppViewComponent.styles';
const FlowStepMessage = styled.div.withConfig({
  displayName: "AppMessagingComponent__FlowStepMessage",
  componentId: "yj9zta-0"
})(["display:grid;align-content:center;", " @media ", "{margin:0 auto;}"], props => !props.isFramedCentredStep && `  margin: 2rem auto;`, devices.desktop);
export const AppMessagingComponent = () => {
  const {
    currentStep
  } = useCurrentStep();
  const {
    shouldDisplayMessaging
  } = useMessage();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  return shouldDisplayMessaging ? /*#__PURE__*/_jsx(FlowStepMessage, {
    "data-step": currentStep,
    isFramedCentredStep: isFramedCentredStep,
    children: /*#__PURE__*/_jsx(MessagingContentHolder, {
      children: /*#__PURE__*/_jsx(MessagingContainer, {})
    })
  }) : null;
};